export default __webpack_public_path__ + "static/media/kid-welcome.e13790de.jpg";